// extracted by mini-css-extract-plugin
export var background = "HeroMobile-module--background--35c65";
export var base = "HeroMobile-module--base--6f6b2";
export var container = "HeroMobile-module--container--9f7ad";
export var logo = "HeroMobile-module--logo--bfd8b";
export var newsletterAdvert = "HeroMobile-module--newsletter-advert--4ff8e";